import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-location.dto';
export * from './dtos/location-list.dto';
export * from './dtos/location-record.dto';
export * from './dtos/location-activity-event.dto';
export * from './dtos/location-activity-event-hydration.dto';
export * from './dtos/location-search.dto';
export * from './dtos/location-public-search.dto';
export * from './dtos/locations-stats.dto';
export * from './dtos/update-location.dto';

export * from './enums/location-type.enum';
export * from './enums/location-status.enum';
export * from './enums/location-action.enum';

export * from './functions/location-status-to-color.function';

export * from './types/locations-filters';

export * from './validators/schemas/create-location.schema';
export * from './validators/schemas/update-location.schema';

export const locationValidators = { canCreateOrUpdate, canPerformAction };
